document.querySelectorAll(".custom-option-btn").forEach((btn) => {
  btn.addEventListener("click", function () {
    // Remove "active" class from all buttons
    document
      .querySelectorAll(".custom-option-btn")
      .forEach((b) => b.classList.remove("active"));

    // Add "active" class to the clicked button
    this.classList.add("active");

    // Handleize function: Converts text to lowercase, replaces spaces with hyphens
    function handleize(str) {
      return str
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^a-z0-9-]/g, "");
    }

    // Get parent element
    const parentPicker = document.querySelector(
      ".product-info__variant-picker"
    );

    if (parentPicker) {
      // Remove previously added handleized classes
      parentPicker.classList.forEach((cls) => {
        if (cls.startsWith("variant-")) {
          parentPicker.classList.remove(cls);
        }
      });

      // Add new handleized class
      parentPicker.classList.add(`variant-${handleize(this.innerText)}`);
    }
  });
});
if (document.getElementById("copyBtn") != null) {
  document.getElementById("copyBtn").addEventListener("click", function () {
    const code = document.getElementById("codeBox").textContent;
    navigator.clipboard
      .writeText(code)
      .then(() => {
        const button = document.getElementById("copyBtn");
        button.textContent = "Copied!";
        button.classList.add("copied");

        setTimeout(() => {
          button.textContent = "Copy";
          button.classList.remove("copied");
        }, 1500); // Reset after 1.5 seconds
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  });
}
document.querySelectorAll(".product-gallery__media").forEach((media) => {
  media.addEventListener("click", function (event) {
    event.stopPropagation(); // 🛑 Stop bubbling let workedstate = false;
    const variantGallery = media.closest(".variant-metafield-images");
    if (!variantGallery) return;

    const thumbnails = variantGallery.querySelectorAll(
      ".product-gallery__thumbnail-list-wrapper page-dots .product-gallery__thumbnail"
    );
    const cursor = variantGallery.querySelector(".product-gallery__cursor");
    console.log("thumbnails", thumbnails);

    if (!thumbnails.length || !cursor) return;

    let currentIndex = -1;

    thumbnails.forEach((thumb, index) => {
      if (thumb.getAttribute("aria-current") === "true") {
        currentIndex = index;
      }
    });

    if (cursor.classList.contains("is-half-end")) {
      // Move forward
      console.log(currentIndex, "currentIndex");
      if (currentIndex >= 0 && currentIndex + 1 < thumbnails.length) {
        thumbnails[currentIndex + 1].click();
      } else {
        thumbnails[1]?.click();
      }
    } else if (cursor.classList.contains("is-half-start")) {
      // Move backward
      console.log(currentIndex, "currentIndex");
      if (currentIndex > 0) {
        thumbnails[currentIndex - 1].click();
      } else {
        thumbnails[0]?.click();
      }
    }
  });
});
